import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function Row({ children, ...props }: FlexProps) {
  return (
    <Flex
      align="center"
      gap={{ base: "tiniest", lg: "tinier" }}
      textStyle="caption2"
      fontSize={{ base: "brand.2xs", lg: "brand.2xs" }}
      fontWeight="semibold"
      flexWrap={{ base: "wrap", lg: "nowrap" }}
      {...props}
    >
      {children}
    </Flex>
  );
}
